export default "__VITE_ASSET__f48b0b4c__"